import React, { useContext, useEffect, useState, useMemo } from 'react'
import { getHqChallenges } from '../../../../api'
import { AuthContext } from '../../../../auth-context'
import HqChallengeTable from './components/hq-challenge-table'

const HqChallenges = () => {
  const { user } = useContext(AuthContext)
  const [hqChallengesState, updateHqChallengesState] = useState(0)
  const [hqChallenges, updateHqChallenges] = useState(null)

  const fetchHqChallenges = useMemo(() => {
    updateHqChallengesState(1)
    return getHqChallenges(user.id).then((res) => {
      updateHqChallenges(res.data.hq_challenges)
      updateHqChallengesState(2)
    })
  }, [updateHqChallengesState, updateHqChallenges, user.id])

  useEffect(() => {
    if (hqChallengesState === 0 && user.id) {
      fetchHqChallenges()
    }
  }, [hqChallengesState, user.id, fetchHqChallenges])

  return (
    <React.Fragment>
      <HqChallengeTable hqChallengesState={hqChallengesState} hqChallenges={hqChallenges} />
    </React.Fragment>
  )
}

export default HqChallenges